<style scoped>

</style>
<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="valuedis"
        :label="label"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      :value="value"
      no-title
      :locale="locale"
      :type="type"
      scrollable
      range
      @input="changeDate"
    />
  </v-menu>
</template>
<script>
  export default {
    props: {
      value: {
        type: Array
      },
      label: {
        type: String,
        default: '选择日期'
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      locale: {
        type: String,
        default: 'zh'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      type: {
        type: String,
        default: () => undefined
      },
      showButton: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        menu: false,
      
      }
    },
    computed: {
      valuedis() {
        return this.value.join('~')
      }
    },
    methods: {
      changeDate(date) {
        this.$emit('changeDate', date)
      },
    }
  }
</script>
